<template>
	<tinymce-editor v-model="editorValue" :init="editorInit" :disabled="!enableEditor"></tinymce-editor>
</template>

<script>
	import Api from '../../api/index.js';
	// 引入组件
	import tinymce from 'tinymce/tinymce';
	import TinymceEditor from '@tinymce/tinymce-vue';
	import 'tinymce/icons/default/icons';
	import 'tinymce/themes/silver';
	// 引入富文本编辑器主题的js和css
	import 'tinymce/themes/silver/theme.min';
	import 'tinymce/skins/ui/oxide/skin.min.css';
	// 扩展插件
	import 'tinymce/plugins/image';
	import 'tinymce/plugins/link';
	import 'tinymce/plugins/code';
	import 'tinymce/plugins/table';
	import 'tinymce/plugins/lists';
	import 'tinymce/plugins/wordcount'; // 字数统计插件
	import 'tinymce/plugins/media'; // 插入视频插件
	import 'tinymce/plugins/template'; // 模板插件
	import 'tinymce/plugins/fullscreen';
	import 'tinymce/plugins/paste';
	import 'tinymce/plugins/preview';
	import 'tinymce/plugins/contextmenu';
	import 'tinymce/plugins/textcolor';

	export default {
		model: {
			prop: 'value',
			event: 'changeValue'
		},
		components: {
			TinymceEditor
		},
		props: {
			enableEditor: {
				type: Boolean,
				default: true
			},
			value: {
				type: String,
				default: ''
			},
			plugins: {
				type: [String, Array],
				default: 'link lists image code table wordcount media fullscreen preview paste contextmenu textcolor'
			},
			toolbar: {
				type: [String, Array],
				default: 'fontselect| fontsizeselect | bold italic underline strikethrough table fullscreen  | link  image media  | undo redo  | alignleft aligncenter alignright alignjustify | bullist numlist | forecolor backcolor | outdent indent blockquote | code | removeformat'
			}
		},
		data() {
			return {
				editorInit: {
					language_url: `/tinymce/langs/zh_CN.js`,
					language: 'zh_CN',
					skin_url: `/tinymce/skins/ui/oxide`,
					content_css: `/tinymce/skins/content/default/content.css`,
					content_style: '* { padding:0; margin:0; } img {max-width:100% !important }',
					plugin_preview_width: 375, // 预览宽度
					plugin_preview_height: 200,
					lineheight_val: '1 1.1 1.2 1.3 1.35 1.4 1.5 1.55 1.6 1.75 1.8 1.9 1.95 2 2.1 2.2 2.3 2.4 2.5 2.6 2.7 2.8 3 3.1 3.2 3.3 3.4 4 5',
					fontsize_formats: '8pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 24pt 36pt',
					font_formats: '思源黑体", "Helvetica Neue", Helvetica, Arial, sans-serif',
					plugins: this.plugins,
					powerpaste_word_import: 'merge',
					toolbar: this.toolbar,
					height: 400,
					media_live_embeds: true, //视频的内嵌代码预览是否开启，为ture时富文本编辑框可实现预览功能
					paste_data_images: true,
					statusbar: true, // 底部的状态栏
					menubar: false, // 最上方的菜单
					branding: false, // 水印“Powered by TinyMCE”
					images_upload_handler: (blobInfo, success, fail) => {
						this.handleImgUpload(blobInfo, success, fail);
					},
					//自定义逻辑替换 Tinymce 的默认媒体嵌入逻辑   
				}
			};
		},
		mounted() {
			this.tinymceInstance = tinymce.init({});
		},
		computed: {
			editorValue: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit('changeValue', val);
				}
			}
		},
		methods: {
			// 处理图片上传
			handleImgUpload (blobInfo, success, fail) {
				// const MAX_SIZE = 1 * 1024 * 1024;
				// var size = blobInfo.blob().size,
				var type = blobInfo.blob().type,
					name = blobInfo.blob().name,
					cate = name.indexOf(".") != -1
					? name.split(".")[1]
					: "",
					base64 = `data:${ type };base64,${ blobInfo.base64() }`,
					pic_name = `${ new Date().getTime() }_${ name }`;
				// if (size > MAX_SIZE) {
				// 	fail('图片大小不能大于1M！');
				// 	return false;
				// }
				if (cate != 'jpg' && cate != 'png') {
					fail('图片类型只能为jpg或者png！');
					return false;
				}
				let requestData = {
					base: base64,
					picName: pic_name,
					type: 'uGateWayUrl'
				};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						success(res.data.data.imgUrl);
					} else {
						fail(res.data.message);
					}
				}, (e) => {
					fail(e.message);
				});
			}
		}
	};
</script>
